/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
declare let PixelEvents: any;
declare let sys: any;
declare let base: any;
declare let hall: any;
declare let WebDefine: any;
declare function log(...args: any[]): void;
import { ModuleBase } from './ModuleBase'

export class FaceBookModule extends ModuleBase {
  public userAgent = '' // client_user_agent浏览器代理信息

  init(): void {}

  onClear(): void {}

  onLoad(): void {}

  onDestroy(): void {}

  inits2c(): void {}

  onPreloadData(): void {}

  requestFaceBookSend(eventName: string, _money?: any, _goods_id?: any) {
    log(`FaceBookModule.requestFaceBookSend eventName = ${eventName}`)
    if (eventName in PixelEvents) {
      const value = PixelEvents[eventName as keyof typeof PixelEvents]
      this._requestFaceBookSend(value)
    }
  }

  _requestFaceBookSend(event_name: any, _money?: any, _goods_id?: any): void {
    log(`FaceBookModule._requestFaceBookSend event_name = ${event_name}`)
    const _fbc = this.readCookie('_fbc')
    const _fbp = this.readCookie('_fbp')
    let _url = ''
    const _urlString = localStorage.getItem('fist_load_url')
    if (_urlString != null) {
      _url = localStorage.getItem('fist_load_url')
    }

    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
      //event_name: event_name,
      client_user_agent: this.userAgent,
      fbc: _fbc,
      fbp: _fbp,
      //money: money == undefined ? 0 : Number(money),
      url: _url,
      //goods_id: goods_id == undefined ? 0 : Number(goods_id),
    }
    console.log(
      'faceBookSend',
      document.cookie,
      'client_user_agent',
      this.userAgent,
      'fbc',
      _fbc,
      '_fbp',
      _fbp,
      'url',
      _url,
    )
    base.httpUtil
      .postJson(WebDefine.faceBookSend, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          log('requestFaceBookSend_success')
        }
      })
      .catch((_error: any) => {
        log('requestFaceBookSend_ failFun')
      })
  }

  readCookie(name: string): string | null {
    if (sys.isBrowser) {
      if (typeof document === 'undefined') return ''

      const search = `${name}=`
      let cookieValue = ''

      if (document.cookie.length > 0) {
        const offset = document.cookie.indexOf(search)
        if (offset !== -1) {
          const start = offset + search.length
          let end = document.cookie.indexOf(';', start)
          if (end === -1) end = document.cookie.length
          try {
            cookieValue = decodeURIComponent(document.cookie.substring(start, end))
          } catch (e) {
            console.error('Cookie解码失败:', e)
          }
        }
      }
      return cookieValue
    }
  }
}
